<template>
    <div class="economy-learning-compare">
        <div class="row">
            <div class="col-lg-6">

                <div class="placeholder">
                    <div class="placeholder__heading">
                        <d-tooltip placement="left" identifier="oekonomi.ebitda" />
                        Kontoplan
                    </div>
                    <div class="placeholder padding">

                        <div class="warning" v-if="accountingYearsCheck && 'last_year_closed' in accountingYearsCheck && accountingYearsCheck.last_year_closed === false && !$auth.user().name.includes('Demo')">
                            <b>OBS! Seneste regnskabsår ({{ accountingYearsCheck.year }}) er ikke lukket i e-conomic.</b>
                            Dette betyder, at tallene i din kontoplan summeres for både seneste regnskabsår samt det nuværende. Log in på e-conomic og luk det seneste regnskabsår for at se de korrekte tal. OBS! Du kan lukke og åbne et regnskabsår lige så ofte, det er nødvendigt.
                        </div>
                        
                        <div class="ebitda-wrapper" v-if="sortedAccounts">
                            <div class="line top">
                                <div class="name">Konto</div>
                                <div class="balance">Realiseret&nbsp;/&nbsp;bogført</div>
                                <!--<div class="budget">Budget</div>
                                <div class="diff">Afvigelse</div>-->
                            </div>

                            <div
                                class="line"
                                v-for="accountCategory in sortedAccounts"
                                :key="accountCategory.uuid"
                                @click="selectAccountCategory(accountCategory)"
                                :class="{'bold': accountCategory.account_type === 'custom', 'selected': selectedAccountCategory && selectedAccountCategory.uuid === accountCategory.uuid}"
                            >
                                <div class="name">
                                    {{ accountCategory.name }}
                                </div>
                                <div class="balance">
                                    {{ accountCategory.total_balance | currency }}
                                </div>
                                <!--<div class="budget">
                                    <span v-if="accountCategory.budget">
                                        {{ accountCategory.budget | currency }}
                                    </span>
                                    <span v-else>-</span>
                                </div>
                                <div class="diff">
                                    <span v-if="accountCategory.difference">
                                        {{ accountCategory.difference | currency }}
                                    </span>
                                    <span v-else>-</span>
                                </div>-->
                            </div>
                        </div>

                        <box-loading height="350" v-else />

                    </div>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="placeholder" v-if="selectedAccountCategory">
                    <div class="placeholder__heading">
                        {{ selectedAccountCategory.name }}
                    </div>
                    <div class="placeholder padding">
                        <div class="ebitda-wrapper child" v-if="selectedAccountCategory.accounts.length > 0">
                            <div class="line top">
                                <div class="name">Konto</div>
                                <div class="balance">Bogført</div>
                                <!--<div class="budget">Budget</div>
                                <div class="diff">Afvigelse</div>-->
                            </div>
                            <div class="line" v-for="account in selectedAccountCategory.accounts" :key="account.account_number" v-if="account.balance && account.balance !== '0.00' && !account.balance.startsWith('0.')">
                                <div class="name">
                                    {{ account.account_number }}
                                    -
                                    {{ account.name }}
                                </div>
                                <div class="balance">
                                    {{ account.balance | currency }}
                                </div>
                                <!--<div class="budget">
                                    {{ account.budget | currency }}
                                </div>
                                <div class="diff">
                                    {{ account.difference | currency }}
                                </div>-->
                            </div>
                            <div class="line">
                                <div class="name">
                                    {{ selectedAccountCategory.name }}
                                </div>
                                <div class="balance">
                                    {{ selectedAccountCategory.total_balance | currency }}
                                </div>
                                <!--<div class="budget">
                                    -
                                </div>
                                <div class="diff">
                                    -
                                </div>-->
                            </div>
                        </div>
                        <div v-else>
                            Denne konto har ingen underkonti
                        </div>
                    </div>
                </div>
                <div v-else>
                    Vælg en konto for at se dens underkonti her
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import "../../../styles/vars.scss";

    .placeholder {
        height: fit-content;
    }

    .ebitda-wrapper {
        font-size: $fontsize--sm;

        &.child .line:last-of-type {
            font-weight: $fontweight--bold;
        }

        .line {
            display: flex;
            cursor: pointer;
            position: relative;

            &:hover {
                background: rgba(0, 0, 0, 0.05);

                &:before {
                    position: absolute;
                    top: -5px;
                    right: -10px;
                    bottom: -5px;
                    left: -10px;
                    content: "";
                    background: transparent;
                    border: 5px solid rgba(0, 0, 0, 0.05);
                    border-right-width: 10px;
                    border-left-width: 10px;
                    border-radius: $borderradius--main;
                }
            }

            &.clickable {
                cursor: pointer;

                &:hover {
                    background: rgba(0, 0, 0, 0.05);
                }
            }

            &.bold {
                font-weight: $fontweight--bold;
            }

            &.selected {
                // border-bottom: 1px dashed $color--dark;
                background: $color--dark;
                color: #fff;
                position: relative;

                &:before {
                    position: absolute;
                    top: -5px;
                    right: -10px;
                    bottom: -5px;
                    left: -10px;
                    content: "";
                    background: transparent;
                    border: 5px solid $color--dark;
                    border-right-width: 10px;
                    border-left-width: 10px;
                    border-radius: $borderradius--main;
                }
            }

            &.top {
                font-weight: $fontweight--bold;
            }

            &:not(:last-of-type) {
                margin-bottom: $margin--small;
            }

            &:last-of-type {
                font-weight: $fontweight--bold;

                > div:not(.name) {
                    // text-decoration: underline;
                }
            }

            .name {
                flex-grow: 1;
                padding-right: $padding--small;
            }

            .balance, .budget, .diff {
                flex: 0 0 120px;
                text-align: right;
            }
        }
    }

</style>

<script>
import * as economyService from '@/services/economyService'

export default {
    data () {
        return {
            accountingYearsCheck: null,
            accounts: null,
            selectedAccountCategory: null,
            loading: true
        }
    },
    created () {
        this.getData()
        this.getContentfulData()
    },
    methods: {
        getContentfulData () {
            const contentful = require('contentful')
            const client = contentful.createClient({
            // This is the space ID. A space is like a project folder in Contentful terms
            space: '3h0kg5qa88is',
            // This is the access token for this space. Normally you get both ID and the token in the Contentful web app
            accessToken: 'KL17Lh_FTD4ZN6iksXFClsWCVJ_OEVVUbIt7RUGofwc'
            })
            // This API call will request an entry with the specified ID from the space defined at the top, using a space-specific access token.
            client
            .getEntry('4SzlILGMZwweEFr9myvbxT')
            .then(entry => {
                console.log(entry)
                console.log(entry.fields.tekst.content)
            })
            .catch(err => console.log(err))
        },
        getData () {
            economyService.accountPlan({}, (response) => {
                this.accounts = response.data
                this.loading = false
                this.checkAccountingYears()
            }, (err) => {
                this.loading = false
                console.log(err)
            })
        },
        selectAccountCategory (accountCategory) {
            this.selectedAccountCategory = accountCategory
        },
        checkAccountingYears () {
            economyService.accountingYearsCheck({}, (response) => {
                this.accountingYearsCheck = response.data
            }, (err) => {
                console.log(err)
            })
        }
    },
    computed: {
        sortedAccounts () {
            if (this.accounts) {
                let arr = []
                this.accounts.forEach((account) => {
                    if (!Array.isArray(account)) {
                        arr.push(account)
                    } else {
                        account.forEach((child) => {
                            arr.push(child)
                        })
                    }
                })
                console.log(arr)
                return arr
            }
        },
        calculatedEbitda () {
            if (this.accounts) {
                let ebitda = 0
                this.accounts.forEach((account) => {
                    ebitda += account.total_balance
                })
                return ebitda
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// ebitda.vue?bd0ea5dc